module.exports = __webpack_public_path__ + "static/media/2016_conf_Introduction_to_Modern_Product_Discovery.5b37029b.png";